export const userConstants = {
  SIGNUP_REQUEST: 'USER_SIGNUP_REQUEST',
  SIGNUP_SUCCESS: 'USER_SIGNUP_SUCCESS',
  SIGNUP_FAILURE: 'USER_SIGNUP_FAILURE',

  SIGNIN_REQUEST: 'USER_SIGNIN_REQUEST',
  SIGNIN_SUCCESS: 'USER_SIGNIN_SUCCESS',
  SIGNIN_FAILURE: 'USER_SIGNIN_FAILURE',

  LOGOUT_REQUEST: 'USER_LOGOUT_REQUEST',
  LOGOUT_SUCCESS: 'USER_LOGOUT_SUCCESS',
  LOGOUT_FAILURE: 'USER_LOGOUT_FAILURE',

  UPDATE_REQUEST: 'USER_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'USER_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'USER_UPDATE_FAILURE',

  USER_VALIDATE_REQUEST: 'USER_VALIDATE_REQUEST',
  USER_VALIDATE_SUCCESS: 'USER_VALIDATE_SUCCESS',
  USER_VALIDATE_FAILURE: 'USER_VALIDATE_FAILURE',

  PASSWORD_RECOVERY_REQUEST: 'USER_PASSWORD_RECOVERY_REQUEST',
  PASSWORD_RECOVERY_SUCCESS: 'USER_PASSWORD_RECOVERY_SUCCESS',
  PASSWORD_RECOVERY_FAILURE: 'USER_PASSWORD_RECOVERY_FAILURE',

  DELETE_REQUEST: 'USER_DELETE_REQUEST',
  DELETE_SUCCESS: 'USER_DELETE_SUCCESS',
  DELETE_FAILURE: 'USER_DELETE_FAILURE',

  LIST_REQUEST: 'USER_LIST_REQUEST',
  LIST_SUCCESS: 'USER_LIST_SUCCESS',
  LIST_FAILURE: 'USER_LIST_FAILURE'
}